import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './home/home.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
  ],
  providers: [  { provide: 'LOCALSTORAGE', useFactory: getLocalStorage } ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function getLocalStorage() {
    return (typeof window !== "undefined") ? window.localStorage : null;
}